import * as React from 'react';
import { observer } from 'mobx-react';

/**
 * 静音循环视频
 * @param className
 * @param cover
 * @param src
 * @param autoPlay
 * @param callback;
 * @returns {JSX.Element}
 * @constructor
 */
const SilentVideo = ({
  className,
  cover,
  src,
  autoPlay = true,
  callback = function() {
    // console.log('done', src);
  },
  ...rest
}) => {
  return <video className={className} poster={cover} src={src} muted loop autoPlay={autoPlay} onCanPlayThrough={callback} {...rest} />;
};

export default observer(SilentVideo);
